import { React, useState, useEffect } from "react";
import request from "../../../../Helpers/API";
import { MenuItem, Modal, Checkbox, FormControlLabel } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { TextField } from "@mui/material";
import { ValOnlyNumber } from "../../../../Validators/ValOnlyNumber";



export const ModalComentariosTimeline = ({ open, onClose, folio, tipo, update = null }) => {
    const [datafiltro, setDatafiltro] = useState([]);
    const fecha = new Date(Date.now() + 86400000).toISOString().slice(0, 10);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [state, setState] = useState({
        comentario: "",
        tipo_contacto: "",
        fase: "",
        horometro: 0,
        recordatorio: "",
        activarRecordatorio: false,
        folio: "",
    });

    useEffect(() => {
        if (!folio)
            return
        onExecute();
    }, [open]);

    const onExecute = () => {
        setLoader({ ...loader, mostrar: true });

        request
            .get(`ComentariosTimelineMensajeria/Listado?idcomentario=${folio}&tipo=${tipo}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                if (Array.isArray(result) && result.length > 0) {
                    setDatafiltro(result);
                }
                else {
                    setDatafiltro([]);
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                console.error(error);
            });
    };



    const onGuardar = () => {
        const hoy = new Date().toISOString().slice(0, 10);

        if (state.comentario === "") {
            Swal.fire("COMENTARIO", "Favor de agregar el comentario", "info");
            return;
        }
        if (state.horometro === "") {
            Swal.fire("COMENTARIO", "Favor de agregar el horometro del equipo", "info");
            return;
        }
        if (state.fase === "") {
            Swal.fire("COMENTARIO", "Favor de agregar la fase", "info");
            return;
        }
        if (state.fase === "FC" && !state.folio) {
            Swal.fire("COMENTARIO", "Favor de agregar el folio de factura", "info");
            return;
        }
        if (state.recordatorio !== "" && state.recordatorio <= hoy) {
            Swal.fire(
                "RECORDATORIO",
                "La fecha del recordatorio debe ser mayor a la fecha actual",
                "info"
            );
            return;
        }
        if (state.tipo_contacto === "") {
            Swal.fire("COMENTARIO", "Favor de agregar el tipo de contacto", "info");
            return;
        }
        setLoader({ ...loader, mostrar: true });

        const post = {
            idcomentario: folio,
            tipo: tipo,
            comentario: state.comentario,
            tipo_contacto: state.tipo_contacto,
            fase: state.fase,
            horometro: state.horometro,
            recordatorio: state.recordatorio,
            documento_factura: state.folio
        }
        request
            .post("ComentariosTimelineMensajeria/Guardar", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire({
                    title: "COMENTARIO",
                    text: "Comentario registrado con exito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setDatafiltro(result);
                setState({
                    comentario: ""
                });
                update()
                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("COTIZACIONES", JSON.stringify(error), "error");
                return;
            });
    };

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setState({
            ...state,
            [prop]: sinComas,
        });
    };


    const onCerrar = () => {
        setState({
            ...state,
            comentario: "",
            tipo_contacto: "",
            fase: "",
            horometro: 0,
            recordatorio: "",
        })
        onClose()
    }

    const returnContacto = (tipo_contacto, fase) => {

        const tipo = tipo_contacto === "LL" ? "Llamada" : tipo_contacto === "WA" ? "Whatsapp" : tipo_contacto === "VI" ? "Visita" : tipo_contacto === "CO" ? "Correo" : "Sin identificar"

        const fase_entregado = fase === "CI" ? "Cliente interesado" : fase === "TE" ? "Tiempo de entrega" : fase === "PR" ? "Precio de refacción" : fase === "AB" ? "Atención brindada" : fase === "NN" ? "No se necesitó" : "Sin identificar"
        return `${tipo}: ${fase_entregado}`
    }
    return (
        <>
            <Modal open={open} onClose={onCerrar}>
                <div className="modal-comentarios-timeline-formulario-main-container">
                    <div className="comentarios-cotizaciones-modal-plantilla">
                        <div
                            className="plantilla-screen-filtro-container"
                            id="mdlFiltros-modal"
                        >
                            <PlantillaScreen
                                titulo={tipo === "CO" ? "COMENTARIOS COTIZACION" : tipo === "SE" ? "COMENTARIOS SERVICIO" : "COMENTARIOS GARANTIA"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onCerrar}>
                                    X
                                </div>
                                <div className={`comentarios-cotizaciones-modal`}>
                                    <div className="comentarios-cotizaciones-modal-container">
                                        <div className="listado-precios-usados-buscador-container">

                                            <div className="comentario-timeline-tipo-contacto-header-control">
                                                <div className='titulo-selector'>Tipo de contacto</div>
                                                <div className='selector-tipo'>
                                                    <div className={`tipo ${state.tipo_contacto === "LL" ? "selected" : ""}`}
                                                        onClick={() => setState({ ...state, tipo_contacto: "LL" })}>
                                                        Llamada
                                                    </div>
                                                    <div className={`tipo ${state.tipo_contacto === "WA" ? "selected" : ""}`}
                                                        onClick={() => setState({ ...state, tipo_contacto: "WA" })}>
                                                        Whatsapp
                                                    </div>
                                                    {/* <div className={`tipo ${state.tipo_contacto === "VI" ? "selected" : ""}`}
                                                        onClick={() => setState({ ...state, tipo_contacto: "VI" })}>
                                                        Visita
                                                    </div> */}
                                                    <div className={`tipo ${state.tipo_contacto === "CO" ? "selected" : ""}`}
                                                        onClick={() => setState({ ...state, tipo_contacto: "CO" })}>
                                                        Correo
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="listado-clientes-gestionar-header-control">
                                                <TextField
                                                    color="success"
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    value={state.comentario}
                                                    onChange={({ target }) =>
                                                        setState({ ...state, comentario: target.value })
                                                    }
                                                    placeholder="Comentario"
                                                />
                                            </div>

                                            <div className="listado-clientes-gestionar-header-control">

                                                {tipo === "CO" ? (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Fase"
                                                        variant="outlined"
                                                        className="cel-1"
                                                        select
                                                        type="text"
                                                        onChange={({ target }) => {
                                                            setState({
                                                                ...state,
                                                                fase: target.value,
                                                            });
                                                        }}
                                                        value={state.fase}
                                                    >
                                                        <MenuItem value={"CI"}>Cliente Interesado</MenuItem>
                                                        <MenuItem value={"TE"}>Tiempo de entrega</MenuItem>
                                                        <MenuItem value={"PR"}>Precio de Refacción</MenuItem>
                                                        <MenuItem value={"AB"}>La atención brindada</MenuItem>
                                                        <MenuItem value={"NN"}>No se necesitó</MenuItem>
                                                        <MenuItem value={"FC"}>Facturado</MenuItem>
                                                    </TextField>
                                                ) : tipo === "SE" ? (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Fase"
                                                        variant="outlined"
                                                        className="cel-1"
                                                        select
                                                        type="text"
                                                        onChange={({ target }) => {
                                                            setState({
                                                                ...state,
                                                                fase: target.value,
                                                            });
                                                        }}
                                                        value={state.fase}
                                                    >
                                                        <MenuItem value={"CI"}>Cliente Interesado</MenuItem>
                                                        <MenuItem value={"PS"}>Precio del Servicio</MenuItem>
                                                        <MenuItem value={"CD"}>Credito Disponible</MenuItem>
                                                        <MenuItem value={"AB"}>La atención brindada</MenuItem>
                                                        <MenuItem value={"NN"}>No se necesitó</MenuItem>
                                                    </TextField>
                                                ) : tipo === "GE" ? (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Fase"
                                                        variant="outlined"
                                                        className="cel-1"
                                                        select
                                                        type="text"
                                                        onChange={({ target }) => {
                                                            setState({
                                                                ...state,
                                                                fase: target.value,
                                                            });
                                                        }}
                                                        value={state.fase}
                                                    >
                                                        <MenuItem value={"CI"}>Cliente Interesado</MenuItem>
                                                        <MenuItem value={"CD"}>Cliente no Interesado</MenuItem>
                                                    </TextField>
                                                ) : (
                                                    <div>
                                                    </div>
                                                )}

                                                {tipo !== "CO" && (
                                                    <TextField
                                                        className="pr-5 cel-5"
                                                        size="small"
                                                        label="Horometro"
                                                        variant="outlined"
                                                        type="number"
                                                        inputProps={{
                                                            style: { textAlign: "right" },
                                                        }}
                                                        error={state.bcantidad}
                                                        onChange={({ target }) => {
                                                            ValOnlyNumber("horometro", target.value, onChange, true, 10);
                                                        }}
                                                        value={state.horometro}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                height: "40px",
                                                            },
                                                            "& input": {
                                                                textAlign: "right",
                                                                padding: "10px 14px", // ajusta el centrado vertical
                                                            },
                                                        }}
                                                    />
                                                )}
                                                {state.fase === "FC" ? (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Folio"
                                                        variant="outlined"
                                                        className="cel-1"
                                                        // select
                                                        type="text"
                                                        onChange={({ target }) => {
                                                            setState({
                                                                ...state,
                                                                folio: target.value,
                                                            });
                                                        }}
                                                        value={state.folio}
                                                    >

                                                    </TextField>

                                                ) : (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={state.activarRecordatorio}
                                                                onChange={(e) =>
                                                                    setState({
                                                                        ...state,
                                                                        activarRecordatorio: e.target.checked,
                                                                        recordatorio: e.target.checked
                                                                            ? fecha
                                                                            : "", // limpia si se desactiva
                                                                    })
                                                                }
                                                                color="success"
                                                            />
                                                        }
                                                        label="Activar recordatorio"
                                                    />
                                                )}

                                                {state.activarRecordatorio && (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Recordatorio"
                                                        variant="outlined"
                                                        className="cel-1-1"
                                                        type="date"
                                                        onChange={({ target }) => {
                                                            setState({ ...state, recordatorio: target.value });
                                                        }}
                                                        value={state.recordatorio}
                                                    />
                                                )}
                                            </div>
                                            <div>
                                                <div
                                                    className="btn-serviciomdlguardar"
                                                    onClick={() => onGuardar()}
                                                >
                                                    Guardar
                                                </div>
                                            </div>
                                        </div>
                                        <div className="comentarios-cotizaciones-modal-container-table scroll-4">
                                            <table cellPadding={0} cellSpacing={0}>
                                                <thead>
                                                    <tr>
                                                        {/* <th>Numero</th> */}
                                                        <th>
                                                            Comentario
                                                        </th>
                                                        <th>
                                                            <div> contacto</div>
                                                        </th>
                                                        {/* <th>
                                                            <div>Fase</div>
                                                        </th> */}
                                                        {tipo !== "CO" && (
                                                            <th>
                                                                <div>Horometro</div>
                                                            </th>
                                                        )}
                                                        <th>
                                                            <div>Recordar</div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datafiltro.map((item, index) => (
                                                        <tr key={index}>
                                                            {/* <td>{item.orden}</td> */}
                                                            <td className="td-comentario">
                                                                {item.comentario}
                                                            </td>
                                                            <td className="td-contacto">{returnContacto(item.tipo_contacto, item.fase)}</td>
                                                            {/* <td>{item.fase === "CI" ? "Cliente interesado" : item.fase === "TE" ? "Tiempo de entrega" : item.fase === "PR" ? "Precio de refacción" : item.fase === "AB" ? "Atención brindada" : item.fase === "NN" ? "No se necesitó" : "Sin identificar"}</td> */}
                                                            {tipo !== "CO" && (
                                                                <td style={{ textAlign: 'end' }}>{item.horometro}</td>
                                                            )}
                                                            <td td > {item.recordatorio === "01/01/1900" ? "" : item.recordatorio}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div >
            </Modal >
        </>
    );
};
